import React from 'react';
import PropTypes from 'prop-types';

function FilterBar({ options, selectedFilter, onFilterChange, className = "" }) {
  return (
    <div className={`flex gap-2 mb-8 overflow-x-auto pb-1 -mx-1 px-1 ${className}`}>
      {options.map((option) => (
        <button
          key={option.id}
          onClick={() => onFilterChange(option.id)}
          className={`flex-shrink-0 flex items-center px-4 py-1.5 text-sm font-medium rounded-full transition-all whitespace-nowrap ${
            selectedFilter === option.id
              ? 'bg-orange-100 text-orange-700 border border-orange-200'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-transparent'
          }`}
        >
          {option.icon && <option.icon className="w-4 h-4 mr-1.5" />}
          {option.label}
        </button>
      ))}
    </div>
  );
}

FilterBar.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType, // Icon component (optional)
    })
  ).isRequired,
  selectedFilter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default FilterBar;
